/**
 * RepBuddy - Admin service
 * Reads the internal usage-metrics dashboard data from the authenticated backend.
 * The endpoint is DEV_EMAILS-gated server-side; this just attaches the session token.
 */
import { supabase } from '../lib/supabaseClient';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3001';

async function authedHeaders() {
  const base = { 'Content-Type': 'application/json' };
  if (!supabase) return base;
  try {
    const { data: { session } } = await supabase.auth.getSession();
    if (!session?.access_token) return base;
    return { ...base, Authorization: `Bearer ${session.access_token}` };
  } catch {
    return base;
  }
}

// Returns { users, metrics, count, generatedAt }. Throws an Error with `.status` set so the
// page can tell 403 (not a developer) apart from other failures.
export async function fetchUsageMetrics() {
  const headers = await authedHeaders();
  const res = await fetch(`${BACKEND_URL}/api/admin/usage-metrics`, { method: 'GET', headers });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    const err = new Error(data.error || `Request failed (${res.status}).`);
    err.status = res.status;
    throw err;
  }
  return res.json();
}
